export default "__VITE_ASSET__a274393e__"